import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ReactGA4 from "react-ga4";
import { useLocation } from "react-router-dom";
import clevertap from "clevertap-web-sdk";
import "./ContactUs.css";

function ContactUs() {
  const location = useLocation();

  useEffect(() => {
    ReactGA4.send("pageview", location.pathname);
    clevertap.event.push("Page Viewed", {
      Page_name: "ContactUs Page",
    });
  }, []);

  return (
    <div className="contactus-page">
      <Helmet>
        <title>Broking.life - Contact Us</title>
        <meta
          name="description"
          content="Basic details of Shareway Securities Pvt Ltd, Key Managerial Personnel, and Escalation Matrix."
        />
      </Helmet>

      <h1 className="contactus-title">Annexure B: Mandatory Display Details</h1>

      {/* Basic Details of the Stock Broker */}
      <section className="contactus-section">
        <h2 className="contactus-heading">Basic Details of the Stock Broker</h2>
        <div className="contactus-table-wrapper">
          <table className="contactus-table">
            <thead>
              <tr>
                <th>Stock Broker Name</th>
                <th>Registration Number</th>
                <th>Registered Address</th>
                <th>Branch Office</th>
                <th>Contact Number</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Shareway Securities Pvt Ltd</td>
                <td>INZ000208134</td>
                <td>Old no 46 new no 6, Gilli flower, flat, E-2nd floor, 23rd street, Anna Nagar East, Chennai 600102</td>
                <td>294/1, 7th Cross, Domlur Layout, Bangalore - 560071</td>
                <td>080-45687111</td>
                <td><a href="mailto:compliance@broking.life">compliance@broking.life</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Details of Contact Person */}
      <section className="contactus-section">
        <h2 className="contactus-heading">Details of Contact Person</h2>
        <div className="contactus-table-wrapper">
          <table className="contactus-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Prajwal D K</td>
                <td>Head of Customer Care</td>
              </tr>
              <tr>
                <td>Ramesh L</td>
                <td>Customer Care</td>
              </tr>
              <tr>
                <td>Kunal Ambasta</td>
                <td>Compliance Officer</td>
              </tr>
              <tr>
                <td>Paritosh Kumar Gunjan</td>
                <td>CEO</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Escalation Matrix */}
      <section className="contactus-section">
        <h2 className="contactus-heading">Escalation Matrix</h2>
        <div className="contactus-table-wrapper">
          <table className="contactus-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Address</th>
                <th>Contact No.</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Prajwal D K</td>
                <td>Signet Wing A, Cessna Business Park, Bengaluru, Karnataka 560103</td>
                <td>8722391271</td>
                <td><a href="mailto:prajwal@broking.life">prajwal@broking.life</a></td>
              </tr>
              <tr>
                <td>2</td>
                <td>Ramesh L</td>
                <td>Signet Wing A, Cessna Business Park, Bengaluru, Karnataka 560103</td>
                <td>9841455600</td>
                <td><a href="mailto:ramesh@broking.life">ramesh@broking.life</a></td>
              </tr>
              <tr>
                <td>3</td>
                <td>Kunal Ambasta</td>
                <td>Signet Wing A, Cessna Business Park, Bengaluru, Karnataka 560103</td>
                <td>6300880979</td>
                <td><a href="mailto:compliance@broking.life">compliance@broking.life</a></td>
              </tr>
              <tr>
                <td>4</td>
                <td>Paritosh Kumar Gunjan</td>
                <td>Signet Wing A, Cessna Business Park, Bengaluru, Karnataka 560103</td>
                <td>9599588124</td>
                <td><a href="mailto:paritosh@broking.life">paritosh@broking.life</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Key Managerial Personnel */}
      <section className="contactus-section">
        <h2 className="contactus-heading">Key Managerial Personnel</h2>
        <div className="contactus-table-wrapper">
          <table className="contactus-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Mobile Number</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Mr. Paritosh Kumar Gunjan</td>
                <td>CEO</td>
                <td>9599588124</td>
                <td><a href="mailto:paritosh@broking.life">paritosh@broking.life</a></td>
              </tr>
              <tr>
                <td>2</td>
                <td>Mr. Anuj Bajpai</td>
                <td>Designated Director</td>
                <td>9109918008</td>
                <td><a href="mailto:anuj@broking.life">anuj@broking.life</a></td>
              </tr>
              <tr>
                <td>3</td>
                <td>Mr. Manoj J Shah</td>
                <td>Company Secretary</td>
                <td>9845251554</td>
                <td><a href="mailto:manojshahj@gmail.com">manojshahj@gmail.com</a></td>
              </tr>
              <tr>
                <td>4</td>
                <td>Mr. Aniket Dilip Shirke</td>
                <td>Director</td>
                <td>7718957000</td>
                <td><a href="mailto:aniket@broking.life">aniket@broking.life</a></td>
              </tr>
              <tr>
                <td>5</td>
                <td>Mr. Kunal Ambasta</td>
                <td>Compliance Officer</td>
                <td>6300880979</td>
                <td><a href="mailto:compliance@broking.life">compliance@broking.life</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Details of Authorized Persons */}
      <section className="contactus-section">
        <h2 className="contactus-heading">Details of Authorized Persons</h2>
        <p className="contactus-nil">NIL</p>
      </section>
    </div>
  );
}

export default ContactUs;
